import React from 'react';
import { getFileName } from '../vibeCodingUtils';

const EditorTab = ({ openTabs, selectedPath, isDirty, onSelectFile, onCloseTab }) => {
  if (!openTabs || !openTabs.length) return null;

  return (
    <>
      {openTabs.map((tabPath) => {
        const isActive = tabPath === selectedPath;
        const tabName = getFileName(tabPath);
        return (
          <div
            key={tabPath}
            className={`vibe-editor-tab d-flex align-items-center ${isActive ? 'active' : ''}`}
            title={tabPath}
          >
            <button
              type="button"
              className="vibe-editor-tab__select btn btn-link btn-sm text-decoration-none"
              onClick={() => onSelectFile(tabPath)}
            >
              <span>{tabName}</span>
              {isActive && isDirty ? <span className="vibe-dirty-dot ml-1">●</span> : null}
            </button>
            <button
              type="button"
              className="vibe-editor-tab__close btn btn-link btn-sm text-decoration-none px-1"
              onClick={(event) => onCloseTab(tabPath, event)}
              aria-label={`Close ${tabName}`}
            >
              ×
            </button>
          </div>
        );
      })}
    </>
  );
};

export default EditorTab;
